import { render, staticRenderFns } from "./CheckoutV2Iframe.vue?vue&type=template&id=268f4d4f&scoped=true"
import script from "./CheckoutV2Iframe.vue?vue&type=script&lang=ts"
export * from "./CheckoutV2Iframe.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutV2Iframe.vue?vue&type=style&index=0&id=268f4d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f4d4f",
  null
  
)

export default component.exports